var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailGreenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3748 6.37525C10.6069 6.37525 10.8295 6.28304 10.9936 6.1189C11.1578 5.95475 11.25 5.73213 11.25 5.5C11.25 5.26787 11.1578 5.04525 10.9936 4.8811C10.8295 4.71696 10.6069 4.62475 10.3748 4.62475H6.87525V1.12525C6.87525 0.893119 6.78304 0.670496 6.6189 0.506355C6.45475 0.342214 6.23213 0.25 6 0.25C5.76787 0.25 5.54525 0.342214 5.3811 0.506355C5.21696 0.670496 5.12475 0.893119 5.12475 1.12525V4.62475H1.62525C1.39312 4.62475 1.1705 4.71696 1.00635 4.8811C0.842214 5.04525 0.75 5.26787 0.75 5.5C0.75 5.73213 0.842214 5.95475 1.00635 6.1189C1.1705 6.28304 1.39312 6.37525 1.62525 6.37525H5.12475V9.87475C5.12475 10.1069 5.21696 10.3295 5.3811 10.4936C5.54525 10.6578 5.76787 10.75 6 10.75C6.23213 10.75 6.45475 10.6578 6.6189 10.4936C6.78304 10.3295 6.87525 10.1069 6.87525 9.87475V6.37525H10.3748Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailGreenIcon);
export default __webpack_public_path__ + "static/media/DetailGreenIcon.32f13c7a89b149c5d953f7ad6467b5d3.svg";
export { ForwardRef as ReactComponent };